import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Message, SpinnerService, UtilsService } from 'shared-components';
import { AdminContextService } from '../../context/admin-contex.service';
import { AdminService } from '../../services/admin.service';
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-mantenimiento-paises',
    templateUrl: './mantenimiento-paises.component.html'
})
export class MantenimientoPaisesComponent implements OnInit, OnDestroy {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 10;

    private _filters;
    public filtersVisible = false;
    public filtersForm: UntypedFormGroup;

    public paises;

    public mensajes = new Array<Message>();
    public showError: boolean;

    public deleteModal = false;
    public newEditModal = false;

    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    public toEditId;
    public toDeleteId;
    public toTranslateId;

    public pestanaActiva = new Array<number>();

    public nombreComponente;
    public dropdownSection: number;

    public orderBy: string;
    public columnId: number;

    private readonly destroy$ = new Subject<void>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _sessionContext: SessionContextService,
        private readonly _adminContext: AdminContextService,
        private readonly _adminService: AdminService,
        private readonly utilsService: UtilsService,
        private readonly _translate: TranslateService
    ) {}

    ngOnInit() {
        this.nombreComponente = "MantenimientoPaisesComponent"
        this.filtersForm = this._fb.group({
            pais: [''],
            fechaInicio: [''],
            fechaFin: [''],
            esProductor: [false],
            esDestino: [false],
            isO3: [''],
            dateType: ['false']
        });

        this._adminContext.mantenimientoPaisesFilters = null;

        this.getPaises();

        this.filtersForm.get('fechaInicio').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());
        this.filtersForm.get('fechaFin').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public get defaultLanguage() {
      return this._translate.getDefaultLang();
    }

    public applyFilters() {
        this.currentPage = 0;
        this._adminContext.mantenimientoPaisesFilters = {
            desPaisDefecto: this.filtersForm.get('pais').value ? this.filtersForm.get('pais').value : '',
            fechaInicio: this.filtersForm.get('fechaInicio').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaInicio').value) : '',
            fechaFin: this.filtersForm.get('fechaFin').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaFin').value) : '',
            fechaActualizacion: this.filtersForm.get('dateType').value,
            esProductor: this.filtersForm.get('esProductor').value ? this.filtersForm.get('esProductor').value : '',
            esDestino: this.filtersForm.get('esDestino').value ? this.filtersForm.get('esDestino').value : '',
            isO3: this.filtersForm.get('isO3').value ? this.filtersForm.get('isO3').value : '',
            numPagina: this.currentPage,
            tamPagina: this.itemsPerPage,
        }

        this.getPaises();
    }

    public get isSmallScreen(){
      return this._sessionContext.isSmallScreen();
    }

    public get idiomaId(){
      return this._sessionContext.sessionUser.idiomaId;
    }

    public getPaises() {
        if (this._adminContext.mantenimientoPaisesFilters) {
            this._filters = this._adminContext.mantenimientoPaisesFilters;
        } else {
            this.applyFilters();
        }
        this._spinnerService.showSpinner();
        this._adminService.getPaises(this._filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.totalItems = resp.paginacionMeta.totalCount;
            this.paises = resp.lista;
        }, (error) => {
            this.pushMessage('global.error.noResponse');
        });
    }

    private clearDatesValidators() {
        if (this.filtersForm.get('fechaFin').errors && this.filtersForm.get('fechaFin').value) {
            this.filtersForm.get('fechaFin').clearValidators();
            this.filtersForm.get('fechaFin').updateValueAndValidity();
        }
        if (this.filtersForm.get('fechaInicio').errors && this.filtersForm.get('fechaInicio').value) {
            this.filtersForm.get('fechaInicio').clearValidators();
            this.filtersForm.get('fechaInicio').updateValueAndValidity();
        }
    }

    public validDates() {
        if (this.filtersForm.get('fechaInicio').value && this.filtersForm.get('fechaFin').value) {
            if (this.checkDates(this.filtersForm.get('fechaInicio').value, this.filtersForm.get('fechaFin').value)) {
                this.clearDatesValidators();
            } else {
                this.filtersForm.get('fechaInicio').setErrors(['Invalid date']);
                this.filtersForm.get('fechaFin').setErrors(['Invalid date']);
            }
            if (this.filtersForm.get('fechaInicio').invalid || this.filtersForm.get('fechaFin').invalid) {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.fecha.error.finAnteriorInicio'});
            } else {
                this.showError = false;
                this.mensajes = [];
            }
        } else {
            this.clearDatesValidators();
            this.showError = false;
            this.mensajes = [];
        }
    }

    private checkDates(inicio, fin) {
        const inicioD = new Date(inicio);
        const finD = new Date(fin);
        return inicioD <= finD;
    }

    public checkValuesForm(): boolean {
        return (this.filtersForm.get('fechaInicio').value ||
                this.filtersForm.get('fechaFin').value ||
                this.filtersForm.get('isO3').value ||
                (this.filtersForm.get('pais').value && this.filtersForm.get('pais').enabled)) ? true : false;
    }

    public resetForm() {
        this.filtersForm.reset();
        this.filtersForm.get('dateType').patchValue('false');
    }

    public filtrar() {
        this.validDates();
        if (this.filtersForm.valid) {
          this.applyFilters();
          this.dropdownSection = -1;
        }
    }

    public pageChange(page) {
        this.dropdownSection = -1;
        this._adminContext.mantenimientoPaisesFilters.numPagina = this.currentPage = page - 1;
        this.getPaises();
    }

    public itemsPerPageChange(items) {
        this.dropdownSection = -1;
        this._adminContext.mantenimientoPaisesFilters.numPagina = this.currentPage = 0;
        this._adminContext.mantenimientoPaisesFilters.tamPagina = this.itemsPerPage = items;
        this.getPaises();
    }

    public create() {
        this.toEditId = null;
        this.newEditModal = true;
    }

    public update(pais) {
        this.toEditId = pais.id;
        this.newEditModal = true;
    }

    public askDelete(pais) {
        this.toDeleteId = pais.id;
        this.deleteModal = true;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this._adminService.deletePais(this.toDeleteId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then(() => {
            this.close();
            this.pushMessage('global.success.itemDeleted');
            this.getPaises();
        });
    }

    public close() {
        this.deleteModal = false;
        this.newEditModal = false;
    }

    public refresh(value) {
        this.newEditModal = false;
        if (value) {
            this.getPaises();
        }
    }

    public pushMessage(mensaje) {
        this.showError = true;
        if (mensaje.includes('error') || mensaje.includes('ApiErrors')) {
            this.mensajes.push({ class: 'error', message: mensaje });
        } else {
            this.mensajes.push({ class: 'success', message: mensaje });
        }
    }

    public openTabs(i) {
        this.dropdownSection = this.dropdownSection === i ? -1 : i;
        this.pestanaActiva[i] = this.pestanaActiva[i] > 0 ? this.pestanaActiva[i] : 1;
        // Desplazamiento a la izquierda para tablet (mismo tamaño máx. que en table.scss)
        if (this.dropdownSection !== -1 && window.innerWidth <= 1199) {
            // Retardo en caso de que haya otro detalle abierto
            setTimeout(() => {
                document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
            }, 50);
        }
    }

    public showSection(i, pais) {
        this.pestanaActiva[i] = 1;
        this.toTranslateId = pais.id;
    }

    public showAsociarMunicipios(i) {
        this.pestanaActiva[i] = 2;
    }

    public toRefresh(value) {
        if (value) {
            this.getPaises();
        }
    }

    public getIcon(prop: string) {
      let iconClass = 'fa fa-sort';
      if (this._filters && this._filters.orderItems && this._filters.orderItems[0].orderProperty === prop) {
          iconClass = this._filters.orderItems[0].orderByDescending === true ? 'fa fa-sort-down' : 'fa fa-sort-up';
      }
      return iconClass;
    }

    public toOrderBy(columnFilter, idColumn) {
      this.columnId = idColumn;
      if (this.paises && this.paises.length > 0) {
        if (this._adminContext.mantenimientoPaisesFilters) {
          this._filters = this._adminContext.mantenimientoPaisesFilters;
          if (!this.orderBy || this.orderBy.includes('DESC')) {
            this.orderBy = 'ASC' + idColumn;
            this._filters.orderItems = [
              {
                orderProperty: columnFilter,
                orderByDescending: false
              }
            ];
          } else if (this.orderBy.includes('ASC')) {
            this.orderBy = 'DESC' + idColumn;
            this._filters.orderItems = [
              {
                orderProperty: columnFilter,
                orderByDescending: true
              }
            ];
          }
          this.getPaises();
        }
      }
    }

    public trackByPaisId(index: number, pais: { id: number }): number {
        return pais.id;
    }
}
